import React from 'react';
import { Search } from 'lucide-react';
export function Sidebar() {
  return <aside className="w-[280px] bg-[#e9dafe] flex-shrink-0 flex flex-col h-full border-r border-gray-200/50" data-id="element-120">
      <div className="p-6" data-id="element-121">
        <h1 className="text-xl font-bold text-[#1e1e1e] mb-6" data-id="element-122">
          Session Replay
        </h1>

        {/* Search Input */}
        <div className="relative mb-6" data-id="element-123">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-124">
            <Search className="h-4 w-4 text-gray-400" data-id="element-125" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2.5 border-none rounded-lg bg-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#8a38f5]/20 shadow-sm" placeholder="Search students...." data-id="element-126" />
        </div>

        {/* Student List */}
        <div className="space-y-2" data-id="element-127">
          {/* Active Student Item */}
          <div className="bg-white rounded-lg p-3 shadow-sm border-l-4 border-[#8a38f5] cursor-pointer" data-id="element-128">
            <div className="flex items-center" data-id="element-129">
              <div className="h-10 w-10 rounded-full bg-[#8a38f5] flex items-center justify-center text-white font-medium text-sm flex-shrink-0" data-id="element-130">
                MC
              </div>
              <div className="ml-3 overflow-hidden" data-id="element-131">
                <p className="text-sm font-bold text-[#1e1e1e] truncate" data-id="element-132">
                  Michael Chen
                </p>
                <p className="text-xs text-gray-500 truncate" data-id="element-133">
                  24 Chats • Last Jan 10
                </p>
              </div>
            </div>
          </div>

          {/* Inactive items would go here */}
        </div>
      </div>
    </aside>;
}